"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryListRequest = void 0;
var QueryListRequest = /** @class */ (function () {
    function QueryListRequest() {
        this.pageNum = 1;
        this.pageSize = 10;
    }
    return QueryListRequest;
}());
exports.QueryListRequest = QueryListRequest;
;
//# sourceMappingURL=queryList.request.js.map